/**
 * Created by okolesnikov.
 */
import {BonusScene} from 'bonus_scene';

import {Animation} from 'animation';
import {Commands}from 'commands';
import {SmartObject} from 'commands';
import sea_background from 'sea_background';

import { TYPE, canGo } from "network/network_api";

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;
const BitmapText = PIXI.extras.BitmapText;

const COLUMNS = 4;
const ROWS = 5;
const TIME_FULL_ROAD = 3000;
const SCALE_PER_CELL = 0.1;
const OFFSET_X_PER_CELL = [25, 10, -5, -20, -40];
const Y_CELL_CENTER = [650, 500, 385, 290, 205];

const DIRECTION = {
    UP: 1,
    DOWN: -1
}

function createAnimation(name_pattern, framesCount, speed = 0.2, loop = false) {

    let anim = Animation.byFrameName(name_pattern, framesCount);
    anim.animationSpeed = speed;
    anim.loop = loop;

    return anim;
}

export default class BonusGameScene extends BonusScene {
    
    constructor(space, secondChance) {
        super();

        this.secondChance = secondChance;

        this.interactive = true;

        this.background = new Sprite(TextureCache['res/sea_backgrounds/sea_background_0.jpg']);
        this.addChild(this.background);

        this.animateBack = new sea_background();
        this.background.addChild(this.animateBack);

        const grid = new Sprite(TextureCache['res/bonus/bonus_grid.png']);
        grid.position.set(0, 153);
        this.addChild(grid);

        // по столбцам, сверху-вниз, слева-направо
        const cellPosition = [
            {x: 228,y: 143},
            {x: 213,y: 214},
            {x: 198,y: 305},
            {x: 179,y: 416},
            {x: 155,y: 547},
            {x: 347,y: 143},
            {x: 344,y: 214},
            {x: 341,y: 305},
            {x: 337,y: 416},
            {x: 333,y: 547},
            {x: 462,y: 143},
            {x: 470,y: 214},
            {x: 478,y: 305},
            {x: 490,y: 416},
            {x: 503,y: 547},
            {x: 577,y: 143},
            {x: 593,y: 214},
            {x: 614,y: 305},
            {x: 639,y: 416},
            {x: 668,y: 547}
        ];

        this.cells = [];
        this.lightCells = [];

        for (let i = 0; i < COLUMNS; ++i) {
            let colCells = [];
            let colLightCells = [];
            for (let j = 0; j < ROWS; ++j) {
                let cell = new Sprite(TextureCache['cell_%d_%d.png'.$(i, j)]);
                cell.position = cellPosition[(i * 5)+j];
                colCells.push(cell);
                this.addChild(cell);

                let lightCell = new Sprite(TextureCache['yellow_cell_%d_%d.png'.$(i, j)]);
                lightCell.position = cellPosition[(i * 5)+j];
                colLightCells.push(lightCell);
                this.addChild(lightCell);
            }
            this.cells.push(colCells);
            this.lightCells.push(colLightCells);
        }

        this.animMonster = SmartObject.mixin(createAnimation('bonus_monster_%03d.png', 18, 0.3));
        let revTexture = this.animMonster.textures.slice().reverse();
        this.animMonster.textures = this.animMonster.textures.concat(revTexture);
        this.animMonster.anchor.set(0.5, 0.5);
        this.addChild(this.animMonster);

        this.animMonsterFail = createAnimation('monster_fail_%03d.png', 18, 0.3);
        revTexture = this.animMonsterFail.textures.slice().reverse();
        this.animMonsterFail.textures = this.animMonsterFail.textures.concat(revTexture);
        this.animMonsterFail.anchor.set(0.5, 0.5);
        this.addChild(this.animMonsterFail);

        this.animMonsterEat = createAnimation('bonus_monster_eat_%03d.png', 24, 0.25);
        this.animMonsterEat.anchor.set(0.5, 0.5);
        this.addChild(this.animMonsterEat);

        this.animMonsterEatFail = createAnimation('monster_eat_fail_%03d.png', 24, 0.25);
        this.animMonsterEatFail.anchor.set(0.5, 0.5);
        this.addChild(this.animMonsterEatFail);

        this.animVortex = createAnimation('bonus_whirlpool_%03d.png', 9, 0.2, true);
        this.animVortex.anchor.set(0.5, 0.5);
        this.addChild(this.animVortex);

        this.boatContainer = SmartObject.mixin(new PIXI.Container());
        //this.boatContainer.position.set(100, 650);
        this.addChild(this.boatContainer);

        this.animBoatMoveUp = createAnimation('boat_move_up_%03d.png', 12, 0.2, true);
        this.animBoatMoveUp.anchor.set(0.5, 0.5);
        this.boatContainer.addChild(this.animBoatMoveUp);

        this.animFisherUp = createAnimation('bonus_fisher_up_%03d.png', 17, 0.3, true);
        this.animFisherUp.anchor.set(0.5, 0.5);
        this.animBoatMoveUp.addChild(this.animFisherUp);

        this.animBoatCrashUp = createAnimation('boat_crash_up_%03d.png', 10);
        this.animBoatCrashUp.anchor.set(0.5, 0.5);
        this.boatContainer.addChild(this.animBoatCrashUp);

        this.animBoatMoveDown = createAnimation('boat_move_down_%03d.png', 13, 0.2, true);
        this.animBoatMoveDown.anchor.set(0.5, 0.5);
        this.boatContainer.addChild(this.animBoatMoveDown);

        this.animFisherDown = createAnimation('bonus_fisher_down_%03d.png', 20, 0.3, true);
        this.animFisherDown.anchor.set(0.5, 0.5);
        this.animBoatMoveDown.addChild(this.animFisherDown);

        this.animBoatCrashDown = createAnimation('boat_crash_down_%03d.png', 10);
        this.animBoatCrashDown.anchor.set(0.5, 0.5);
        this.boatContainer.addChild(this.animBoatCrashDown);

        this.labelWin = new BitmapText("123456789", {font: "bonus_font", align: "center"});
        this.labelWin.anchor.set(0.5, 1.0);
        this.labelWin.position.set(0, -90);
        this.boatContainer.addChild(this.labelWin);

        this.labelBonusWin = new BitmapText("123456789", {font: "bonus_totalwin_font", align: "center"});
        this.labelBonusWin.anchor.x = 0.5;
        this.labelBonusWin.position.set(512, 700);
        this.addChild(this.labelBonusWin);

        this.tableEndBonus = new Sprite(TextureCache["table_after_bonus.png"]);
        this.tableEndBonus.anchor.set(0.5, 0.5);
        this.tableEndBonus.position.set(1024/2, 768/2 - 50);
        this.tableEndBonus.visible = false;
        this.addChild(this.tableEndBonus);

        this.labelTableWin = new BitmapText("123456789", {font: "bonus_table_font", align: "center"});
        this.labelTableWin.anchor.x = 0.5;
        this.labelTableWin.position.set(0, -30);
        this.tableEndBonus.addChild(this.labelTableWin);

        this.pressFinish = new Sprite(TextureCache["press_finish.png"]);
        this.pressFinish.anchor.x = 0.5;
        this.pressFinish.position.set(0, 80);
        this.tableEndBonus.addChild(this.pressFinish);

        this.tableEndBonus.interactive = false;
        this.tableEndBonus.pointerdown = event => {
            if (event.data.originalEvent.button != null && event.data.originalEvent.button != 0) {
                return;
            }
            space.s('ui:finish').next();
            this.tableEndBonus.interactive = false;
        };

        this.extraLife = new Sprite(TextureCache['res/extra_life.png']);
        this.extraLife.position.set(931, 567 - 50);
        this.extraLife.visible = false;
        this.addChild(this.extraLife);

        this.scaleScreeen = new Sprite(TextureCache['res/sea_backgrounds/sea_background_0.jpg']);
        this.scaleScreeen.anchor.x = 1.0;
        this.scaleScreeen.position.set(1024, 0);
        this.addChild(this.scaleScreeen);

        this.sndShowCell = sounds.get("res/sounds/bonus/show_cell");
        this.sndShowCell.volume(0.2);
        this.sndSelectCell = sounds.get("res/sounds/bonus/select_cell");
        this.sndShowMonster = sounds.get("res/sounds/bonus/monster_show");
        this.sndShowMonster.volume(0.4);
        this.sndShowWin = sounds.get("res/sounds/bonus/bonus_show_win");
        this.sndMonsterStart = sounds.get("res/sounds/bonus/monster_fight_start");
        this.sndMonsterEnd = sounds.get("res/sounds/bonus/monster_fight_end");
        this.sndVortex = sounds.get("res/sounds/bonus/vortex");
        this.sndVortex.loop(true);
        this.sndPuddle = sounds.get("res/sounds/bonus/puddle");
        this.sndPuddle.loop(true);
        this.sndPuddle.rate(0.6);
        this.sndPuddle.volume(0.4);
        this.sndBoatReset = sounds.get("res/sounds/bonus/boat_reset");

        this.sndTransition = sounds.get("res/sounds/bonus/transition_to_super");
        this.sndFlow = sounds.get("res/sounds/bonus/bonus_flow");
        this.sndFlow.loop(true);
        this.sndFlow.volume(0.3);
        this.sndFlowStart = sounds.get("res/sounds/bonus/bonus_flow_start");
        this.sndFlowStart.on('end', () => {
            this.sndFlow.play();
        });

        this.sndShowTable = sounds.get("res/sounds/show_table");
        this.sndShowTable.loop(true);

        this.flowTween = null;
        this.intervalShowCell = null;
        this.scaleTween = null;
        this.currentCell = 0;
        this.currentColumn = 0;
        this.currentDirection = DIRECTION.UP;
        this.currentBonusWin = 0;

        /*this.clickArea = new PIXI.Graphics();
        this.clickArea.hitArea = new PIXI.Rectangle(0, 0, 1024, 768);
        this.clickArea.pointerdown = () => {
            this.selectCell();
        };
        this.clickArea.interactive = false;
        this.addChild(this.clickArea);*/

        const hitAreaPointX = [
            [266, 380, 492, 605, 718],
            [256, 376, 498, 620, 744],
            [242, 374, 508, 642, 778],
            [226, 370, 520, 668, 820],
            [208, 368, 532, 696, 865],
            [185, 362, 548, 734, 924]
        ];

        const hitAreaPointY = [169, 244, 336, 445, 575, 746];

        this.hitAreas = [];

        for (let px = 0; px < 4; ++px) {
            let colAreas = [];
            for (let py = 0; py < 5; ++py) {
                let area = new PIXI.Graphics();
                area.lineStyle(1, 0xFF0000, 1);

                area.beginFill(0x0011FF);
                area.moveTo(hitAreaPointX[py][px], hitAreaPointY[py]);
                area.lineTo(hitAreaPointX[py][px + 1], hitAreaPointY[py]);
                area.lineTo(hitAreaPointX[py + 1][px + 1], hitAreaPointY[py + 1]);
                area.lineTo(hitAreaPointX[py + 1][px], hitAreaPointY[py + 1]);
                area.lineTo(hitAreaPointX[py][px], hitAreaPointY[py]);
                area.endFill();

                area.pointerdown = () => {
                    //console.log('click ', px, py);//
                    this.selectCell(py);
                };

                area.interactive = false;
                area.alpha = 0.0;
                this.addChild(area);
                colAreas.push(area);
            }

            this.hitAreas.push(colAreas)
        }

    };

    terminate() {

        this.pause();

        this.animateBack.terminate();

        this.tableEndBonus.removeListener('pointerdown');
        this.hitAreas.forEach(col => {
            col.forEach(a => a.removeListener('pointerdown'))
        });

        this.sndShowCell.stop();
        this.sndSelectCell.stop();
        this.sndShowMonster.stop();
        this.sndPuddle.stop();
        this.sndShowWin.stop();
        this.sndMonsterStart.stop();
        this.sndMonsterEnd.stop();
        this.sndVortex.stop();
        this.sndBoatReset.stop()
        this.sndTransition.stop();
        this.sndFlow.stop();
        this.sndFlowStart.stop();
        this.sndFlowStart.off('end');

        this.animMonster.stop();
        this.animMonsterEat.stop();
        this.animMonsterFail.stop();
        this.animMonsterEatFail.stop();
        this.animVortex.stop();

        this.animBoatCrashUp.stop();
        this.animFisherUp.stop();
        this.animBoatMoveUp.stop();
        this.animBoatCrashDown.stop();
        this.animFisherDown.stop();
        this.animBoatMoveDown.stop();

        this.removeChildren();
        this.destroy();

        this.cells = null;
        this.lightCells = null;
        this.animMonster = null;
        this.animMonsterEat = null;
        this.animMonsterFail = null;
        this.animMonsterEatFail = null;
        this.animVortex = null;
        this.animBoatCrashUp = null;
        this.animFisherUp = null;
        this.animBoatMoveUp = null;
        this.animBoatCrashDown = null;
        this.animFisherDown = null;
        this.animBoatMoveDown = null;
        this.boatContainer = null;
        this.labelBonusWin = null;
        this.labelWin = null;
        this.tableEndBonus = null;
        this.labelTableWin = null;
        this.pressFinish = null;
        this.extraLife = null;

        this.sndShowCell = null;
        this.sndSelectCell = null;
        this.sndShowMonster = null;
        this.sndPuddle = null;
        this.sndShowWin = null;
        this.sndMonsterStart = null;
        this.sndMonsterEnd = null;
        this.sndVortex = null;
        this.sndShowTable = null;
        this.sndTransition = null;
        this.sndFlow = null;
        this.sndFlowStart = null;
        this.sndBoatReset = null;

    };

    update(dt, time) {
        super.update(dt, time);

        this.boatContainer.updateCommands(dt);
        this.animMonster.updateCommands(dt);
    };

    selectCell(cell) {
        //this.clickArea.interactive = false;

        this.hitAreas.forEach(col => {
            col.forEach(a => a.interactive = false)
        });

        this.showChoiceCell(cell);
        this.stopMoveMonster();
        this.onUserSelect(this.currentCell);
    }

    // @overridden
    selectionHasMade(variant) {
        console.log("SELECTION HAS MADE: variant = ", variant);

    };

    pause() {

        this.hitAreas.forEach(col => {
            col.forEach(a => a.interactive = false)
        });

        this.sndShowTable.stop();

        this.boatContainer.clear();
        this.animMonster.clear();

        if (this.intervalShowCell) {
            clearInterval(this.intervalShowCell);
            this.intervalShowCell = null;
        }

        if (this.flowTween) {
            this.flowTween.stop();
        }

        if (this.finishBlinkTween) {
            this.finishBlinkTween.stop();
        }

        if (this.scaleTween) {
            this.scaleTween.stop();
        }

        this.animateBack.stopAnimate();
    };

    
    flowWin (addWin, done) {

        const flowTimeCoeff = 800;
        //const val = this.currentBonusWin ? this.currentBonusWin : 1;
        const time = flowTimeCoeff * Math.log(addWin) || 100;
        let win = addWin;
        let prev = this.currentBonusWin ? this.currentBonusWin : 1;

        const totalWin = {
            value: this.currentBonusWin ? this.currentBonusWin : 1,
        };

        if (this.flowTween) {
            this.flowTween.stop();
        }

        this.currentBonusWin += addWin;

        this.sndFlowStart.play();

        this.flowTween = new TWEEN.Tween(totalWin)
            .to({value: this.currentBonusWin}, time)
            .delay(800)
            .onUpdate(() => {
                let d = totalWin.value - prev;
                prev = totalWin.value;
                win = win - d;
                this.labelWin.text = Math.floor(win);
                this.labelBonusWin.text = 'WIN ' + Math.floor(totalWin.value);
            })
            .onStop(() => {
                this.labelBonusWin.text = 'WIN ' + this.currentBonusWin;
            })
            .onComplete(() => {
                this.labelWin.visible = false;
                this.labelBonusWin.text = 'WIN ' + this.currentBonusWin;
                this.sndFlowStart.stop();
                this.sndFlow.stop();
                if (done) {
                    done();
                }
            })
            .start();
    };

    showBoatMoveAnimation() {
        if (this.currentDirection === DIRECTION.UP) {
            this.animBoatMoveDown.stop();
            this.animFisherDown.stop();
            this.animBoatMoveDown.visible = false;

            this.animBoatMoveUp.visible = true;
            this.animBoatMoveUp.gotoAndPlay(0);
            this.animFisherUp.gotoAndPlay(0);
        }
        else {
            this.animBoatMoveUp.stop();
            this.animFisherUp.stop();
            this.animBoatMoveUp.visible = false;

            this.animBoatMoveDown.visible = true;
            this.animBoatMoveDown.gotoAndPlay(0);
            this.animFisherDown.gotoAndPlay(0);
        }

        if (!this.sndPuddle.playing()) {
            this.sndPuddle.play();
        }
    }

    stopBoatMoveAnimation() {
        this.sndPuddle.stop();
        if (this.currentDirection === DIRECTION.UP) {
            this.animBoatMoveUp.gotoAndStop(0);
            this.animFisherUp.gotoAndStop(0);
        }
        else {
            this.animBoatMoveDown.gotoAndStop(0);
            this.animFisherDown.gotoAndStop(0);
        }
    }

    reversBoat() {
        if (this.currentDirection === DIRECTION.UP) {
            this.currentDirection = DIRECTION.DOWN;
        }
        else {
            this.currentDirection = DIRECTION.UP;
        }

        this.showBoatMoveAnimation();
    }

    moveBoat(cell, column, done) {

        let toScale = 1.0 - (cell * SCALE_PER_CELL);
        let toX = (100 + column * 180) + (cell * OFFSET_X_PER_CELL[column]);
        let toY = Y_CELL_CENTER[cell];

        let time = (Math.abs(this.boatContainer.y - toY)) / ((Y_CELL_CENTER[0] - Y_CELL_CENTER[4]) / TIME_FULL_ROAD);

        this.boatContainer.addCommand(0, Commands.MoveTo, {x: toX, y: toY}, time);
        if (done) {
            this.boatContainer.addCommand(0, Commands.Call, done);
        }

        this.boatContainer.addCommand(1, Commands.Scale, toScale, time);

    };

    moveBoatCycled() {
        this.boatContainer.clear();

        let xCell0 = 100 + this.currentColumn * 180;
        let xCoords = [xCell0, xCell0 + (4 * OFFSET_X_PER_CELL[this.currentColumn])],
            yCoords = [Y_CELL_CENTER[0], Y_CELL_CENTER[4]],
            scales = [1.0, 0.6];

        if (this.currentDirection === DIRECTION.DOWN) {
            xCoords.reverse();
            yCoords.reverse();
            scales.reverse();
        }

        let timeFirst = Math.floor((Math.abs(this.boatContainer.y - yCoords[1])) / ((Y_CELL_CENTER[0] - Y_CELL_CENTER[4]) / TIME_FULL_ROAD));

        // move to last point
        this.boatContainer.addCommand(0, Commands.MoveTo, {x: xCoords[1], y: yCoords[1]}, timeFirst);
        this.boatContainer.addCommand(1, Commands.Scale, scales[1], timeFirst);

        //cycled move
        this.boatContainer.addCommand(0, Commands.Call, () => {this.reversBoat()});
        this.boatContainer.addCommand(0, Commands.MoveTo, {x: xCoords[0], y: yCoords[0]}, TIME_FULL_ROAD);
        this.boatContainer.addCommand(0, Commands.Call, () => {this.reversBoat()});
        this.boatContainer.addCommand(0, Commands.MoveTo, {x: xCoords[1], y: yCoords[1]}, TIME_FULL_ROAD);
        this.boatContainer.addCommand(0, Commands.GoTo, 0, 1);

        this.boatContainer.addCommand(1, Commands.Scale, scales[0], TIME_FULL_ROAD);
        this.boatContainer.addCommand(1, Commands.Scale, scales[1], TIME_FULL_ROAD);
        this.boatContainer.addCommand(1, Commands.GoTo, 1, 1);

    };

    moveMonsterCycled() {

        this.animMonster.clear(0);

        this.animMonster.addCommand(0, Commands.Wait, 800);
        this.animMonster.addCommand(0, Commands.Call, () => {
            let cell = Math.floor(Math.random() * ROWS);
            let column = this.currentColumn + 1;
            this.animMonster.x = (110 + (column) * 180) + (cell * OFFSET_X_PER_CELL[column]);
            this.animMonster.y = Y_CELL_CENTER[cell];
            this.animMonster.scale.set(1.0 - cell * SCALE_PER_CELL);

            this.animMonster.gotoAndStop(0);
            this.animMonster.visible = true;
            this.sndShowMonster.play();
        });
        this.animMonster.addCommand(0, Commands.Animate, this.animMonster, 0);
        this.animMonster.addCommand(0, Commands.Call, () => {this.animMonster.visible = false});
        this.animMonster.addCommand(0, Commands.GoTo, 0, 0);
    };

    stopMoveMonster() {
        this.animMonster.clear();
        if (this.animMonster.visible) {
            this.animMonster.stop();
            this.animMonster.onComplete = () => {
                this.animMonster.visible = false;
            };
            this.animMonster.gotoAndPlay(this.animMonster.currentFrame);
        }
    };

    showBlueCellCycled() {
        this.currentCell = 0;
        this.cells[this.currentColumn][this.currentCell].visible = true;
        this.sndShowCell.play();
        this.intervalShowCell = setInterval(() => {
            this.cells[this.currentColumn][this.currentCell].visible = false;
            this.currentCell = (this.currentCell + 1) % ROWS;
            this.cells[this.currentColumn][this.currentCell].visible = true;
            this.sndShowCell.play();
        }, 800)
    };

    showChoiceCell(cell) {
        if (this.intervalShowCell) {
            clearInterval(this.intervalShowCell);
        }
        this.sndShowCell.stop();

        this.cells[this.currentColumn][this.currentCell].visible = false;
        if (cell !== undefined) {
            this.currentCell = cell;
        }
        this.lightCells[this.currentColumn][this.currentCell].visible = true;
        this.sndSelectCell.play();
    }


    restoreBonus(data) {
        console.log("RESTORE!!!!!!!!");

        const scenarioData = data.server.scenarioData || [];
        const wins = data.state.stage.math.bonus1Wins || [];
        const mult = data.server.betValue.multiplier;
        const bet = data.server.price();

        this.currentBonusWin = data.server.totalWinInCoins;
        if (wins.length > 0) {
            this.currentBonusWin -= wins[wins.length - 1] * mult;
        }
        this.labelBonusWin.text = this.currentBonusWin ? ('WIN ' +  this.currentBonusWin) : " ";

        this.tableEndBonus.visible = false;
        this.tableEndBonus.interactive = false;
        this.scaleScreeen.visible = false;
        this.animVortex.visible = false;
        for (let i = 0; i < COLUMNS; ++i) {
           for (let j = 0; j < ROWS; ++j) {
               this.cells[i][j].visible = false;
               this.lightCells[i][j].visible = false;
           }
        }
        this.labelWin.visible = false;

        this.animBoatCrashDown.visible = false;
        this.animBoatCrashUp.visible = false;

        this.currentColumn = scenarioData.length;
        this.boatContainer.position.set(100 + (this.currentColumn*180), Y_CELL_CENTER[0]);
        this.boatContainer.scale.set(1.0);

        this.currentDirection = DIRECTION.UP;
        this.showBoatMoveAnimation();

        this.animMonster.visible = false;
        this.animMonsterEat.visible = false;
        this.animMonsterFail.visible = false;
        this.animMonsterEatFail.visible = false;

        //this.clickArea.interactive = false;

        this.hitAreas.forEach(col => {
            col.forEach(a => a.interactive = false)
        });

        if (scenarioData.length === 0) {

            this.moveBoatCycled();

            this.moveMonsterCycled();

            this.showBlueCellCycled();

            this.hitAreas[this.currentColumn].forEach(a => a.interactive = true);

            this.extraLife.visible = (bet > this.secondChance);

            //this.clickArea.interactive = true;
        }
        else {

            this.extraLife.visible = (bet > this.secondChance) && (wins.slice(0, wins.length - 1).indexOf(0) === -1);

            this.currentCell = scenarioData[scenarioData.length - 1];
            this.lightCells[this.currentColumn - 1][this.currentCell].visible = true;
        }

        this.animateBack.startAnimate();
    };

    showPreSuperScene(done) {
        this.scaleScreeen.scale.set(1.0);
        this.scaleScreeen.visible = true;
        this.sndTransition.play();
        this.scaleTween = new TWEEN.Tween(this.scaleScreeen.scale)
            .to({x: 3.0, y: 3.0}, 800)
            .onComplete(() => {
                this.pause();
                setTimeout(done, 2000);
                //done();
            })
            .start();
    };

    // @overridden
    showResult (data, done) {

        console.log('show result data:', data);

        const hasSuperbonus = canGo( TYPE.BONUS_2, data );
        const wins = data.state.stage.math.bonus1Wins || [];
        const scenarioData = data.server.scenarioData || [];
        const mult = data.server.betValue.multiplier;
        let useSecondChance = data.state.stage.math.useSecondChance || false;

        let choiceCell = 0;
        let currentWin = 0;

        const moveBoatToChoiceCell = (cell) => {

            const nextColumn = scenarioData.length;

            return new Promise((resolve, reject) => {
                this.boatContainer.clear();
                if (this.currentColumn < nextColumn) {
                    // end move on previous column
                    let endCell = (this.currentDirection === DIRECTION.UP) ? 4 : 0;
                    this.moveBoat(
                        endCell,
                        this.currentColumn,
                        () => {
                            this.reversBoat();
                            //this.currentColumn = scenarioData.length;
                            this.boatContainer.x = 100 + (nextColumn*180) + (endCell * OFFSET_X_PER_CELL[nextColumn]);
                            this.moveBoat(cell, nextColumn, resolve);
                        })
                }
                else {
                    this.moveBoat(cell, nextColumn, resolve);
                }
            })
        };

        const showWin = () => {

            this.labelWin.text = currentWin;
            this.labelWin.visible = true;
            this.sndShowWin.play();

            this.flowWin(currentWin ,() => {
                if (hasSuperbonus) {
                    console.log("SUPER BONUS COMING");
                    this.showPreSuperScene(done);
                }
                else {
                    this.showBoatMoveAnimation();
                    this.moveBoatCycled();
                    this.showBlueCellCycled();
                    this.moveMonsterCycled();

                    //this.clickArea.interactive = true;
                    this.hitAreas[this.currentColumn].forEach(a => a.interactive = true);

                    done();
                }
                // done();
            })
        };

        const showLose = () => {

            this.animBoatMoveUp.visible = false;
            this.animBoatMoveDown.visible = false;

            const crashAnimation = (this.currentDirection === DIRECTION.UP) ? this.animBoatCrashUp : this.animBoatCrashDown;
            crashAnimation.gotoAndStop(0);
            crashAnimation.visible = true;
            const riseAnimation = useSecondChance ? this.animMonsterFail : this.animMonster;
            const eatAnimation = useSecondChance ? this.animMonsterEatFail : this.animMonsterEat;

            this.animVortex.x = 110 + this.currentColumn * 180 + (choiceCell * OFFSET_X_PER_CELL[this.currentColumn]);
            this.animVortex.y = Y_CELL_CENTER[choiceCell];
            this.animVortex.scale.set(1.0 - SCALE_PER_CELL * choiceCell);
            this.animVortex.visible = true;
            this.animVortex.gotoAndPlay(0);

            this.sndVortex.play();

            this.animMonster.stop();
            this.animMonster.clear(1);
            this.animMonster.addCommand(1, Commands.Wait, 1000);
            this.animMonster.addCommand(1, Commands.Call, () => {
                this.animVortex.stop();
                this.animVortex.visible = false;
            });
            this.animMonster.addCommand(1, Commands.Animate, crashAnimation, 0);
            this.animMonster.addCommand(1, Commands.Call, () => {
                this.sndVortex.stop();
                crashAnimation.visible = false;
                eatAnimation.x = riseAnimation.x = 110 + this.currentColumn * 180 + (choiceCell * OFFSET_X_PER_CELL[this.currentColumn]);
                eatAnimation.y = riseAnimation.y = Y_CELL_CENTER[choiceCell];
                riseAnimation.scale.set(1.0 - SCALE_PER_CELL * choiceCell);
                eatAnimation.scale.set(1.0 - SCALE_PER_CELL * choiceCell);
                riseAnimation.visible = true;
                this.sndMonsterStart.play();
            });
            this.animMonster.addCommand(1, Commands.Animate, riseAnimation, 0, 18);
            this.animMonster.addCommand(1, Commands.Call, () => {
                riseAnimation.visible = false;
                eatAnimation.visible = true;
            });
            this.animMonster.addCommand(1, Commands.Animate, eatAnimation, 0);
            this.animMonster.addCommand(1, Commands.Call, () => {
                riseAnimation.visible = true;
                eatAnimation.visible = false;
                this.sndMonsterStart.stop();
                this.sndMonsterEnd.play();
            });
            this.animMonster.addCommand(1, Commands.Animate, riseAnimation, 19);
            if (useSecondChance) {
                this.animMonster.addCommand(1, Commands.Call, () => {
                    riseAnimation.visible = false;
                    if (this.currentDirection === DIRECTION.UP) {
                        this.animBoatMoveUp.visible = true;
                    }
                    else {
                        this.animBoatMoveDown.visible = true;
                    }

                    this.sndBoatReset.play();
                    this.boatContainer.alpa = 0.0;
                    const blinkTween = new TWEEN.Tween(this.boatContainer)
                        .to({alpha: 1.0}, 400)
                        .start();

                });
                this.animMonster.addCommand(1, Commands.Wait, 1000);
                this.animMonster.addCommand(1, Commands.Call , () => {

                    this.extraLife.visible = false;

                    if (hasSuperbonus) {
                        console.log("SUPER BONUS COMING");
                        this.showPreSuperScene(done);
                    }
                    else {
                        this.showBoatMoveAnimation();
                        this.moveBoatCycled();
                        this.showBlueCellCycled();
                        this.moveMonsterCycled();

                        //this.clickArea.interactive = true;
                        this.hitAreas[this.currentColumn].forEach(a => a.interactive = true);

                        done();
                    }

                });
            }
            else {
                this.animMonster.addCommand(1, Commands.Call, () => {done()});
            }

        };

        if (scenarioData.length > 0) {

            //this.clickArea.interactive = false;
            this.hitAreas.forEach(col => {
                col.forEach(a => a.interactive = false)
            });

            choiceCell = (ROWS - 1) - scenarioData[scenarioData.length - 1];
            currentWin = wins[wins.length - 1] * mult;

           //this.stopMoveMonster();

            //console.log(choiceCell);
            moveBoatToChoiceCell(choiceCell).then(() => {
                this.currentColumn = scenarioData.length;
                this.lightCells[this.currentColumn - 1][this.currentCell].visible = false;
                this.stopBoatMoveAnimation();

                if (currentWin > 0) {
                    showWin();
                }
                else {
                    showLose();
                }
            })

            //done();

        }
        else {
            //this.clickArea.interactive = true;
            this.hitAreas[this.currentColumn].forEach(a => a.interactive = true);

            done();
        }


    };
    
    // @overridden
    showFinishTable(stageMath, bet, done) {

        console.log("SHOW BONUS TABLE: ", stageMath , bet);

        this.sndShowTable.play();

        this.labelTableWin.text = (stageMath.featureWin * bet.multiplier).toString();
        this.tableEndBonus.visible = true;
        this.tableEndBonus.interactive = true;

        this.pressFinish.visible = true;
        this.pressFinish.alpha = 1;
        this.finishBlinkTween = new TWEEN.Tween(this.pressFinish)
            .to({alpha: 0}, 500)
            .yoyo(true)
            .repeat(Infinity)
            .easing(TWEEN.Easing.Cubic.InOut)
            .start();

        done();

    };
}


// WEBPACK FOOTER //
// ./src/bonusgame_scene.es6